import { render } from "./elementSelector.vue?vue&type=template&id=39a64b14&scoped=true"
import script from "./elementSelector.vue?vue&type=script&lang=js"
export * from "./elementSelector.vue?vue&type=script&lang=js"

import "./elementSelector.vue?vue&type=style&index=0&id=39a64b14&lang=scss&scoped=true"

import exportComponent from "D:\\客云\\newQsProject\\qs3_pc_portal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a64b14"]])

export default __exports__